import { render, staticRenderFns } from "./BaseSectionTitle.vue?vue&type=template&id=2a37fd7a&scoped=true&"
import script from "./BaseSectionTitle.vue?vue&type=script&lang=ts&"
export * from "./BaseSectionTitle.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSectionTitle.vue?vue&type=style&index=0&id=2a37fd7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a37fd7a",
  null
  
)

export default component.exports